import ProfileView from "../ProfileView.vue";
import EditProfile from "./../layout/UpdateProfile.vue";

export const profileRoute = [
  {
    path: "/profile",
    name: "profile",
    alias: "/me",
    component: ProfileView,
    meta: {
      key: "view_per",
    },
  },
  {
    path: "/profile/:id/edit",
    name: "edit-profile",
    component: EditProfile,
    meta: {
      key: "edit_per",
    },
  },
];
